<div *ngIf="phaseUUID">
    <div *ngIf="formatDocumentQRCode" class="codeqr" (click)="onClickQR()">
        <div class="img"><img [src]="formatDocumentQRCode" /></div>
    </div>
</div>
